import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'app-text-editor',
  templateUrl: './text-editor.component.html',
  styleUrls: ['./text-editor.component.scss'],
  standalone: false,
})
export class TextEditorComponent implements OnChanges {
  @Output() onTextEntered = new EventEmitter<string>();
  @Output() blurEvent = new EventEmitter<any>();
  @Input() editorContent: string = '';
  @Input() disabled = false;

  /** Same TinyMCE cloud key as interiorweb feedback editor. */
  tinyMceApiKey = 'tw4qxk3t75j45m8n239ik3uvdvs9brqiu987cvek9dqtcgea';

  editorConfig: Record<string, unknown> = {
    height: 220,
    menubar: false,
    branding: false,
    plugins: [
      'advlist',
      'autolink',
      'lists',
      'link',
      'image',
      'charmap',
      'preview',
      'anchor',
      'searchreplace',
      'visualblocks',
      'code',
      'fullscreen',
      'insertdatetime',
      'media',
      'table',
      'wordcount',
    ],
    toolbar:
      'undo redo | blocks | bold italic underline strikethrough | ' +
      'bullist numlist | outdent indent | removeformat | help',
    // Match app responsive-twelve-font-size (iframe CSS cannot use SCSS mixins)
    content_style: `
      body {
        font-family: Helvetica, Arial, sans-serif;
        font-size: 12px;
        line-height: 1.4;
      }
      @media (min-resolution: 120dpi) {
        body { font-size: 10px; }
      }
      @media (min-resolution: 144dpi) {
        body { font-size: 8px; }
      }
    `,
  };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['disabled']) {
      this.editorConfig = {
        ...this.editorConfig,
        readonly: !!this.disabled,
      };
    }
  }

  editorData(newData: string) {
    this.editorContent = newData ?? '';
    this.onTextEntered.emit(this.editorContent);
  }

  onBlur(e: any) {
    this.blurEvent.emit(e);
  }
}
